"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
exports.capitalizeFirstLetter = capitalizeFirstLetter;
//# sourceMappingURL=capitalizeFirstLetter.js.map